















import { Getter, Action, State } from 'vuex-class'
import { Component, Vue, Watch, Mixins, Emit, Prop, Ref } from 'vue-property-decorator'
import { IActionType, IStore } from '@/system/store'
import {
  CREATE_JOB_ACTION,
  CLEAR_UPLOAD
} from '@/system/store/action-types'
import { GET_UPLOAD_DATA, GET_IS_CONNECTED } from '@/system/store/getter-types'
import {
  MIME_TYPES,
  MIME_TYPES_EXCEL,
  ACCEPTED_EXTENSIONS
} from '@/constants'
import { IParsingOptions, IUploadStore } from '@/features/upload/store'
import { PROJECT_LIST_NAME } from '@/features/projectList/projectList.router'
import { getPrepareUploadData } from '@/features/upload/upload.service'
import { IJob } from '@/features/job/store'
import { ICustomer, IUser } from '@/features/auth/store'
import { uploadLocalisationKeys } from '@/features/upload/upload.localisation'
import Notification from '@/shared/Notification.mixin.vue'
import { read, utils, ParsingOptions } from 'xlsx'

interface IStoreFileToS3 {
  url: string,
  formFields: any
}

@Component
export default class UploadButton extends Mixins(Notification) {
  translations = uploadLocalisationKeys
  mimeTypes: string[] = MIME_TYPES
  MAX_FILE_SIZE: number = 100 * 1024 * 1024
  acceptedExtensions = ACCEPTED_EXTENSIONS.join(',')
  file: File

  @Prop()
  readonly selectedSheetName!: string
  @State(({ job }: IStore) => job.job)
  job!: IJob
  @State(({ auth }: IStore) => auth.user)
  user!: IUser
  @State(({ auth }: IStore) => auth.selectedCustomer)
  selectedCustomer!: ICustomer
  @State(({ upload }: IStore) => upload.parsingOptions)
  parsingOptions!: IParsingOptions
  @Getter(GET_UPLOAD_DATA)
  uploadData!: IUploadStore
  @Getter(GET_IS_CONNECTED)
  isConnected!: boolean
  @Action(CREATE_JOB_ACTION)
  createJob!: IActionType
  @Action(CLEAR_UPLOAD)
  clearUpload!: IActionType

  @Emit('chooseSheet')
  chooseSheetDialog (SheetNames: string[]): void { }

  @Watch('isConnected')
  createJobs () {
    this.createJob({
      payload: {
        id: this.selectedCustomer.id
      }
    })
  }

  @Ref()
  fileLoader!: any

  private created (): void {
    if (this.isConnected) {
      this.createJob({
        payload: {
          id: this.selectedCustomer.id
        }
      })
    }
    this.clearUpload()
  }

  checkFiles (files: any): File[] {
    return files.filter(this.isFileValid)
  }

  isFileValid ({ type, size }: File): boolean {
    const isValidMimeType = this.mimeTypes.includes(type)
    const isValidSize = size <= this.MAX_FILE_SIZE
    const isValidFile = isValidMimeType && isValidSize
    console.log(`${type} file received`)

    if (!isValidFile) {
      let msg: string = !isValidMimeType ? this.translations.WRONG_FORMAT_ERROR : this.translations.MAX_SIZE_ERROR

      this.showError(this.$t(msg) as string)
    }

    return isValidFile
  }

  prepareUrlAndFormData ([file]: File[]): Promise<IStoreFileToS3> {
    const uploadData = { ...this.uploadData, ...this.job, sheetName: this.selectedSheetName, dateFormat: this.parsingOptions.xlsDateFormat, delimiterFormat: this.parsingOptions.delimiterFormat || '' }

    console.log(`Date format: ${this.parsingOptions.xlsDateFormat} delimiter ${this.parsingOptions.delimiterFormat} uploadData: ${JSON.stringify(uploadData)}`)
    const { url, form: formFields } = getPrepareUploadData({ uploadData, file })

    return Promise.resolve({ url, formFields })
  }

  goToProducts (): void {
    this.$router.push({ name: PROJECT_LIST_NAME })
  }

  handleAdded ([file]: File[]) {
    const { type } = file
    this.file = file

    if (!MIME_TYPES_EXCEL.includes(type)) {
      return this.upload()
    }
    const reader: FileReader = new FileReader()

    reader.readAsArrayBuffer(file)
    reader.onload = this.onReaderLoaded
  }

  onReaderLoaded (e: ProgressEvent<FileReader>): void {
    const data = e?.target?.result
    const readOptions: ParsingOptions = { type: 'array', bookSheets: true }
    const { SheetNames } = read(data, readOptions)

    this.chooseSheetDialog(SheetNames)
  }

  async upload () {
    const { url, formFields } = await this.prepareUrlAndFormData([this.file])

    this.fileLoader.upload()
  }
}
